import {
  useEffect, useState, useContext, useMemo,
} from 'preact/hooks';
import { route } from 'preact-router';
import { Text, Localizer } from 'preact-i18n';

import { RemoteIcon } from '@svg';

import { Context } from '@store';

import style from './style.module.scss';

function Home() {
  const [isConnecting, setIsConnecting] = useState(false);
  const [isError, setIsError] = useState(false);

  const [{ code }, dispatch] = useContext(Context);

  useEffect(() => {
    document.title = 'Remote for Slides';
  }, []);

  const connectingText = useMemo(() => {
    if (isConnecting) return <Text id="home.connecting">Connecting ...</Text>;
    return <Text id="home.connect">Connect</Text>;
  }, [isConnecting]);

  const updateCode = (e) => {
    setIsError(false);
    dispatch({ type: 'SET_CODE', payload: e.target.value });
  };

  const importFirebase = async () => import(/* webpackChunkName: "firebase-home" */ '@services/firebase/home');

  const connect = async () => {
    try {
      if (!/^\d{6}$/.test(code)) throw new Error();

      setIsConnecting(true);
      setIsError(false);

      const {
        db,
        ref,
        child,
        get,
      } = await importFirebase();

      const dbRef = ref(db);
      const snapshot = await get(child(dbRef, `slides/${code}`));
      if (!snapshot.exists()) throw new Error();
      const data = snapshot.val();
      if (!data || data.offline) throw new Error();
      if (typeof window !== 'undefined') {
        window.gtag('event', 'click', {
          event_category: 'button',
          event_label: 'connect_button',
        });
      }
      route(`/${code}`);
    } catch (e) {
      setIsConnecting(false);
      setIsError(true);
    }
  };

  const onInputKeyUp = (e) => {
    if (e.key === 'Enter') connect();
  };

  return (
    <div class={style.container}>
      <div class={style.home}>
        <RemoteIcon class={style.logo} />
        <h1>{process.env.APP_NAME}</h1>
        <Localizer>
          <input
            class={style.input}
            aria-label={<Text id="home.enter_code_here">Enter code here</Text>}
            placeholder={<Text id="home.enter_code_here">Enter code here</Text>}
            type="number"
            inputmode="decimal"
            enterkeyhint="enter"
            value={code}
            onInput={updateCode}
            onKeyUp={onInputKeyUp}
            error={isError}
          />
        </Localizer>
        <button
          class={style.button}
          disabled={isConnecting}
          onClick={connect}
          type="button"
        >
          { connectingText }
        </button>
        <a
          class={style.button}
          href="//limhenry.xyz/slides/"
          target="_blank"
          rel="noreferrer"
        >
          <Text id="home.how_to_use">How to use?</Text>
        </a>
      </div>
    </div>
  );
}

export default Home;
